export const extractPlainTextFromHtml = (html: string): string => {
  if (typeof html !== 'string') {
    return '';
  }

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  return tempDiv.textContent?.trim() || '';
};
